import * as actions from './actions';

export enum SyncClickActions {
    TRANSFER_LOG = 'TRANSFER_LOG',
    TRANSFER_LOG_ERRORS = 'TRANSFER_LOG_ERRORS',
    SYNC_UPDATE = 'SYNC_UPDATE',
    SYNC_SETTINGS = 'SYNC_SETTINGS',
    SYNC_SYNCHRONISATION_LOG = 'SYNC_SYNCHRONISATION_LOG',
    SYNC_ERROR_LOG = 'SYNC_ERROR_LOG',
    OPEN_COMMITTEE_SELECTOR = 'OPEN_COMMITTEE_SELECTOR',
    TRANSFER_GRADES_TO_EXTERNAL_SYSTEM = 'TRANSFER_GRADES_TO_EXTERNAL_SYSTEM',
    TRANSFER_GRADES_FROM_COMMITTEE = 'TRANSFER_GRADES_FROM_COMMITTEE',

    SYNC_ACTION_CLICKED = 'SYNC_ACTION_CLICKED',
}


export interface SyncState {
    isTransferringGrades: boolean;
    isLoadingExternalTestSync: boolean;
}

export const initialState: SyncState = {
    isTransferringGrades: false,
    isLoadingExternalTestSync: false,
};

export const syncButtonReducer = (state = initialState, action: any) => {
    switch (action.type) {
    case actions.ContextTypeKeys.TRANSFER_GRADES_LOADING:
        return {
            ...state,
            isTransferringGrades: action.payload.isLoading,
        };
    case actions.ContextTypeKeys.SYNC_WITH_EXTERNAL_TEST_LOADING:
        return {
            ...state,
            isLoadingExternalTestSync: action.payload.isLoading,
        };
    default:
        return state;
    }
};
